module.exports = __webpack_public_path__ + "static/media/ht.97ab227b.png";